import { useSearchResources } from '@medplum/react';
import { useMemo } from 'react';
import { ProviderRole } from '@bariendo/lib/constants';
import { formatGivenFamilyName } from '@bariendo/lib/human-name';
import { QUEUE_FILTER_ANY, QueueFilterOption } from '../services/queueFilters';

/** The PN filter's options: every Patient Navigator, by Practitioner id (BAR-2884). */
export function usePatientNavigatorOptions(): { options: QueueFilterOption[]; navigatorIds: Set<string> } {
  const [practitioners] = useSearchResources('Practitioner', {
    '_has:PractitionerRole:practitioner:role': ProviderRole.PATIENT_NAVIGATOR,
    _count: '1000',
  });

  return useMemo(() => {
    const navigators = (practitioners ?? [])
      .filter((practitioner) => practitioner.id)
      .map((practitioner) => ({
        value: practitioner.id as string,
        label: formatGivenFamilyName(practitioner.name?.[0]) || (practitioner.id as string),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    return {
      options: [{ value: QUEUE_FILTER_ANY, label: 'Everyone' }, ...navigators],
      navigatorIds: new Set(navigators.map((navigator) => navigator.value)),
    };
  }, [practitioners]);
}
